import { datadogRum } from '@datadog/browser-rum'

export default function ({ $config }) {
  const { ddAppId: applicationId, ddToken: clientToken, appEnv: env } = $config

  if (clientToken) {
    datadogRum.init({
      applicationId,
      clientToken,
      env,
      site: 'datadoghq.eu',
      service: 'nodefreelancer',
      // version: '1.0.0',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input'
    })
  }
}
